import { api } from './api'

export interface CyclePair {
  pair_id: number
  display_name: string
  prop_size: number
  prop_phase: string
  prop_provider: string
  is_active: boolean
  created_at: string | null
  equity: number | null
  balance: number | null
  ea_last_seen: string | null
  cycle_pnl: number | null
  cycle_pnl_pct: number | null
  total_ops: number
  closed_ops: number
  open_ops: number
  first_op: string | null
  last_close: string | null
}

export interface CycleOperation {
  id: number
  direction: string
  status: string
  prop_open_price: number | null
  broker_open_price: number | null
  prop_close_price: number | null
  broker_close_price: number | null
  prop_lots: number | null
  broker_lots: number | null
  sl_usd: number | null
  tp_usd: number | null
  prop_pnl: number | null
  broker_pnl: number | null
  total_pnl: number | null
  prop_equity_at_open: number | null
  prop_equity_at_close: number | null
  signal_source: string
  created_at: string | null
  closed_at: string | null
  prop_ticket: number | null
  broker_ticket: number | null
}

export interface CycleDetail {
  pair: {
    id: number
    display_name: string
    prop_size: number
    prop_phase: string
    prop_provider: string
    is_active: boolean
    created_at: string | null
  }
  snapshot: {
    equity: number | null
    balance: number | null
    ea_last_seen: string | null
    cycle_pnl: number | null
    cycle_pnl_pct: number | null
  }
  stats: {
    total_ops: number
    closed_ops: number
    open_ops: number
    by_source: Record<string, number>
    by_direction: Record<string, number>
  }
  operations: CycleOperation[]
}

export const cyclesService = {
  getMyPairs: () => api.get<CyclePair[]>('/ixen/my-cycles/pairs'),
  getMyPairDetail: (pairId: number) =>
    api.get<CycleDetail>(`/ixen/my-cycles/pairs/${pairId}/detail`),
}

export default cyclesService
